module.exports = __webpack_public_path__ + "static/img/performance_5.bef44c2b.jpg";